import { render, staticRenderFns } from "./LichSuDichVuVeDienTuForm.vue?vue&type=template&id=794b9a1c&scoped=true"
import script from "./LichSuDichVuVeDienTuForm.vue?vue&type=script&lang=js"
export * from "./LichSuDichVuVeDienTuForm.vue?vue&type=script&lang=js"
import style0 from "./LichSuDichVuVeDienTuForm.vue?vue&type=style&index=0&id=794b9a1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794b9a1c",
  null
  
)

export default component.exports